import React from 'react';
import { View, StyleSheet } from 'react-native';
import I18n from '../../../../components/shared/i18n/I18n.component';
import ImageIcon from '../../../../components/shared/Icon/ImageIcon.component';
import ButtonV2 from '../../../../components/shared/Buttons/ButtonV2.container';
import colors from '../../../../config/colors';

type InviteHistoryEmptyProps = {
	onSend: () => void;
	sending: boolean;
	activeUser: boolean;
};

/** Shown when the user was never invited - the only way to send a first invitation. */
const InviteHistoryEmpty = ({ onSend, sending, activeUser }: InviteHistoryEmptyProps) => (
	<View style={styles.container}>
		<ImageIcon name='starPlaceholder' width={95} height={95} />

		<I18n size={14} color='greyText' style={styles.text}>
			usersManagement.inviteHistory.emptyText
		</I18n>

		{!activeUser && (
			<View style={styles.button}>
				<ButtonV2 preset='outline' onPress={onSend} disabled={sending}>
					<I18n size={15} color='titlePrimary' numberOfLines={1}>
						usersManagement.inviteHistory.sendInvite
					</I18n>
					<ImageIcon
						name='send'
						style={{
							height: 16,
							width: 16,
							marginLeft: '8px',
						}}
					/>
				</ButtonV2>
			</View>
		)}

	</View>
);

const styles = StyleSheet.create({
	container: {
		flex: 1,
		alignItems: 'center',
		paddingTop: 80,
	},
	text: {
		marginTop: 24,
		textAlign: 'center',
	},
	button: {
		marginTop: 24,
	},
});

export default InviteHistoryEmpty;
